import classnames from 'classnames';
import { noop } from 'ramda-adjunct';
import React, { FC } from 'react';
import { TextButton } from '../index';
import styles from './MenuRow.scss';
import { IOuter } from './MenuRow.types';

export const MenuRow: FC<IOuter> = ({ onClick = noop, icon, text, active, className, dataHook }) => (
  <TextButton
    as="div"
    weight="normal"
    size="small"
    skin="dark"
    className={classnames(styles.row, { [styles.active]: active }, className)}
    onClick={onClick}
    dataHook={dataHook}
    prefixIcon={icon}
  >
    {text}
  </TextButton>
);
